module.exports = {
	"articleTitle1": "Silvio",
	"catImage": "yellowstar.png",
	"totalCats": 1,
	"name": "Dominick's",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/content/2008-10-01/not-your-convenience",
	"articleSnippet1": "Sep 24, 2008 ... From the frost-proof ceramic tables on the porch to the tricolored ceramic pillars \ninside the bar, Silvio, the “doorman” at Dominick's, has left his ...",
	"articleSnippet2": "Sep 30, 2008 ... Why does Dominick's, widely known across campus for its pitchers of sangria, \nclose at 10 p.m. each night and shutter its door completely during ...",
	"foodRecommendations": [],
	"articleTitle2": "Not for your convenience",
	"address": "812 Monroe St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.273142,
		"lng": -83.738738
	},
	"totalMisc": 0,
	"categories": {
		"nightlife": 1,
		"location": 1,
		"entertainment": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/dominicks.json
// module id = 864
// module chunks = 0